import { FunctionComponent, SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

/** Shared close icon for dev overlay panels. */
export const DevPanelCloseIcon: FunctionComponent<IconProps> = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d="M18 6L6 18M6 6l12 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DevPanelMinimizeIcon: FunctionComponent<IconProps> = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <path
      d="M5 12h14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const DevPanelPhoneIcon: FunctionComponent<IconProps> = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    {...props}
  >
    <rect
      x="7"
      y="2"
      width="10"
      height="20"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M11 18h2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
